import React from 'react';

interface FunnelPillButtonProps {
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
  ariaLabel?: string;
  className?: string;
  disabled?: boolean;
}

const baseClass = 'relative rounded-[14px] px-3 py-2.5 font-fredoka text-sm font-medium text-center transition-all';
const activeClass =
  'bg-[#E8F6FA] text-[#1a1a1a] border-[2.5px] border-[#008BBC] shadow-[0_6px_18px_rgba(0,139,188,0.14)]';
const inactiveClass =
  'bg-[#90D1E8]/20 text-black/70 border-2 border-transparent hover:border-[#90D1E8] hover:bg-[#E8F6FA]/70';

export const FunnelPillButton: React.FC<FunnelPillButtonProps> = ({
  active,
  onClick,
  children,
  ariaLabel,
  className = '',
  disabled = false,
}) => (
  <button
    type="button"
    onClick={onClick}
    aria-pressed={active}
    aria-label={ariaLabel}
    disabled={disabled}
    className={`${baseClass} ${active ? activeClass : inactiveClass} ${className}`}
  >
    {active && (
      <span
        className="pointer-events-none absolute -right-1.5 -top-1.5 flex h-5 w-5 items-center justify-center rounded-full bg-[#008BBC] text-[11px] font-bold leading-none text-white shadow-sm"
        aria-hidden="true"
      >
        ✓
      </span>
    )}
    {children}
  </button>
);
